module.exports = __webpack_public_path__ + "img/zichanyunyinghoutai.8f380637.png";